import React from "react";
import { Flex, Text } from "@jsq/ds/core";
import { Sizes } from "@jsq/ds/styles";

interface FieldRowProps {
  label: string;
  value: React.ReactNode;
  fieldRowClassName?: string;
  fieldLabelClassName?: string;
  fieldValueClassName?: string;
  labelMinWidth?: string;
}

const FieldRow: React.FC<FieldRowProps> = ({
  label,
  value,
  fieldRowClassName,
  fieldLabelClassName,
  fieldValueClassName,
  labelMinWidth,
}) => {
  // Use class-based styling if className props are provided (QueryPaymentBatch)
  if (fieldRowClassName || fieldLabelClassName) {
    return (
      <div className={fieldRowClassName}>
        <Text variant="regular-sm" className={fieldLabelClassName}>
          {label}
        </Text>
        <Text variant="regular-sm" className={fieldValueClassName}>
          {value}
        </Text>
      </div>
    );
  }

  // Use inline styling with Flex (QueryProcessingPayments)
  return (
    <Flex gap={Sizes.SM} alignItems="flex-start">
      <Text variant="strong-sm" style={{ minWidth: labelMinWidth ?? "200px" }}>
        {label}
      </Text>
      <Text variant="regular-sm">{value}</Text>
    </Flex>
  );
};

export default FieldRow;
export { FieldRow };
export type { FieldRowProps };
